/**
 * TNK-140 phase C — client for /api/card-catalog/search. Powers the
 * Quick View modal's candidate list. Returns the same ResolvedCard
 * shape the resolve endpoint uses, with name + number added.
 */
import { apiFetch } from "@/lib/apiClient";

export interface CatalogCandidate {
  id: string;
  name: string;
  number: string;
  setId: string;
  setName: string;
  rarity?: string;
  supertype?: string;
  subtypes?: string[];
  typeLine?: string;
  hp?: string;
  artist?: string;
  language?: string;
  finishes?: string[];
  releasedAt?: string;
  mtgManaCost?: string;
  mtgPowerToughness?: string;
  mtgLoyalty?: string;
  mtgOracleText?: string;
  mtgColors?: string[];
  types?: string[];
  pokedexNumbers?: number[];
  series?: string;
  imageSmall?: string;
  imageLarge?: string;
}

export async function searchCardCatalog(opts: {
  q: string;
  game?: string;
  limit?: number;
}): Promise<{ candidates: CatalogCandidate[] }> {
  const qs = new URLSearchParams();
  qs.set("q", opts.q);
  if (opts.game) qs.set("game", opts.game);
  if (opts.limit) qs.set("limit", String(opts.limit));
  const res = await apiFetch(`/api/card-catalog/search?${qs.toString()}`);
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Catalog search → ${res.status}`);
  }
  return (await res.json()) as { candidates: CatalogCandidate[] };
}
